export enum SNACKBAR_VARIANTS {
  DEFAULT = 'default',
  COMMON = 'common',
}

export enum ICON_SIZES {
  SMALL = 'small',
  BIG = 'big',
}
